import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-work-style-three-page',
  templateUrl: './work-style-three-page.component.html',
  styleUrls: ['./work-style-three-page.component.scss']
})
export class WorkStyleThreePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
